import { merge } from "lodash";
import { IVariaveisAmbiente, IAmbienteUnico } from "./types";

const AmbienteEnviado = (process.env.REACT_APP_ENV || "prodWeb") as keyof IVariaveisAmbiente;
const AmbientePadrao: keyof IVariaveisAmbiente = AmbienteEnviado;
const LabelEnviado = (process.env.REACT_APP_LABEL || "Touchone") as keyof IVariaveisAmbiente;

const apiUrl = 'https://api-licenciamento-bff-prod.touchone.com.br';
const apiImagemUrl = 'https://api-imagens.saurus.net.br';
const apiClickupLicUrl = 'https://api-licenciamento-clickup-prod.touchone.com.br/';
const apiTermosUrl = 'https://api-termos-prod.touchone.com.br/';


const apiHomologacao = 'https://api-licenciamento-hom.touchone.com.br'

const apiVersao = 'v2'

const apiPropagandaUrl = 'https://api-propaganda-prod.touchone.com.br';

const _variaveisAmbiente: IVariaveisAmbiente = {
  all: {
    version: "1.32.11",
    googleAppId: "27279191635-5kdincvmbm92lihatr0k4tm1o4kon8ue.apps.googleusercontent.com",
    saurusUtilsWebService: "https://wsmaster.saurus.net.br/v004/serviceMaster.asmx",
    label: LabelEnviado,
    environment: AmbienteEnviado,
    isDev: (["prodWeb"]
      .find(x => x === AmbientePadrao.toString())?.length || 0) === 0,
    apiVersion: apiVersao
  },
  devWeb: {
    apiUrl: process.env.REACT_APP_API_URL || apiHomologacao,
    apiImagemUrl: apiImagemUrl,
    apiClickupLicUrl: apiClickupLicUrl,
    apiTermos: apiTermosUrl,
    apiPropaganda: apiPropagandaUrl,
    facebookAppId: "661218711269424",
    frontUrl: "http://localhost:3000",
    googleMapsKey: 'AIzaSyCDoIa4tkrK_R2B7br7AqiVKk7eYEBdjoo',
  },
  prodWeb: {
    apiUrl: process.env.REACT_APP_API_URL || apiUrl,
    apiImagemUrl: apiImagemUrl,
    apiClickupLicUrl: apiClickupLicUrl,
    apiTermos: apiTermosUrl,
    apiPropaganda: apiPropagandaUrl,
    facebookAppId: "1880946222051906",
    frontUrl: "https://licenciamento.touchone.com.br",
    googleMapsKey: 'AIzaSyCDoIa4tkrK_R2B7br7AqiVKk7eYEBdjoo'
  },
};

const _ambienteUnico =
  (_variaveisAmbiente[AmbientePadrao] as IAmbienteUnico) || _variaveisAmbiente.devWeb;
export const VariaveisAmbiente = merge(_variaveisAmbiente.all, _ambienteUnico);
